var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileViewPersonalDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4L20 17.1892L18 18L18 3L19.5 4Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 18.1745H16.6578C15.9467 18.1745 15.2711 18.4537 14.7733 18.958L13.2533 20.4799C12.56 21.1734 11.4311 21.1734 10.7378 20.4799L9.21777 18.958C8.72 18.4537 8.03556 18.1745 7.33333 18.1745H6.66667C5.19111 18.1745 4 16.9768 4 15.4998V5.67465C4 4.19772 5.19111 3 6.66667 3H17.3333C18.8089 3 20 4.19772 20 5.67465V15.4998C20 16.9678 18.8089 18.1745 17.3333 18.1745Z",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 9.85603C13.1828 9.85603 14.1422 8.89662 14.1422 7.71314C14.1422 6.52967 13.1828 5.57031 11.9993 5.57031C10.8158 5.57031 9.85645 6.52967 9.85645 7.71314C9.85645 8.89662 10.8158 9.85603 11.9993 9.85603Z",
    fill: "#B7CCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.99982C13.2869 9.99982 14.3301 8.95662 14.3301 7.6698C14.3301 6.38298 13.2869 5.33984 12.0001 5.33984C10.7132 5.33984 9.67004 6.38298 9.67004 7.6698C9.67004 8.95662 10.7132 9.99982 12.0001 9.99982Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 15.6623C16.0001 13.8623 14.2101 12.4023 12.0001 12.4023C9.79012 12.4023 8.00012 13.8623 8.00012 15.6623",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileViewPersonalDetails);
export default __webpack_public_path__ + "static/media/MobileViewPersonalDetails.cf3a43fd8acba2fb184d1748fe86279d.svg";
export { ForwardRef as ReactComponent };